
    import * as React from 'react';

    const Diamond16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" fill="none" style={svgStyle}><rect x={7.45801} width={10.6164} height={10.6164} transform="rotate(44.6294 7.45801 0)" fill="white" /></svg>
        </div>
      );
    };

    Diamond16.displayName = 'Diamond16';

    export default Diamond16;
  